<template>
  <transition :name="`slide-${position}`" @after-leave="handleAfterLeave">
    <div v-if="show" :class="[$style.Toast, $style[`Toast--${position}`]]">
      <!-- <div :class="$style.Toast__icon" :style="iconStyle"></div> -->
      <div :class="$style.Toast__container">
        <div :class="$style.Toast__shadow"></div>
        <div :class="$style.Toast__content">{{ message }}</div>
      </div>
    </div>
  </transition>
</template>

<script lang="ts">
import { defineComponent, onMounted, PropType, ref } from 'vue'
import { ToastPositionType } from './interfaces.ts'

export default defineComponent({
  props: {
    message: String,
    position: String as PropType<ToastPositionType>,
  },
  emits: {
    hidden: null,
  },
  setup(props, context) {
    console.log('props', props)
    const show = ref(false)
    onMounted(() => {
      show.value = true
    })
    const hide = () => {
      show.value = false
    }
    const handleAfterLeave = () => {
      context.emit('hidden')
    }
    return {
      show,
      hide,
      handleAfterLeave,
    }
  },
})
</script>

<style>
.slide-left-enter-active,
.slide-left-leave-active,
.slide-center-enter-active,
.slide-center-leave-active {
  transition:
    opacity 0.3s,
    transform 0.3s;
}

.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(-20%);
  opacity: 0;
}

.slide-center-enter-from,
.slide-center-leave-to {
  transform: translateY(40%);
  opacity: 0;
}
</style>

<style lang="scss" module>
.Toast {
  position: fixed;
  top: 30%;
  left: 0;
  right: 0;
  z-index: 9999;
}
.Toast--left {
  left: 40px;
}
.Toast--center {
  left: calc(50% - 127px);
  .Toast__icon {
    left: 50%;
    transform: translateX(-50%);
  }
}
.Toast__icon {
  width: 120px;
  height: 120px;
  position: absolute;
  top: -80px;
  left: 10px;
  background: no-repeat center/cover;
}
.Toast__container {
  position: relative;
  width: 254px;
  margin: 0 auto;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 12px;
  box-shadow: inset 0 0 2px #000;
}
.Toast__shadow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 12px;
  // box-shadow: inset 0 -4px 8px rgba(#00A2FF, 0.24);
}
.Toast__content {
  position: relative;
  padding: 15px 18px;
  font-size: 16px;
  color: #fff;
  text-align: center;
  white-space: pre-wrap;
}
</style>
